export default function () {
  return [
    {
      title: 'Pracownicy',
      to: '/pracownicy',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
    },
    {
      title: 'Ustawienia',
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj'
    }
  ];
}
